export const BASE_API_URL = process.env.REACT_APP_API_URL;
export const CORE_REGISTRY_API_URL = `${BASE_API_URL}/coreregistry`;
export const PRESENCE_API_URL = `${BASE_API_URL}/presence`;
export const USER_API_URL = `${BASE_API_URL}/user`;
export const CALLEVENT_API_URL = `${BASE_API_URL}/callevent`;
export const PARTNERSHIP_API_URL = `${BASE_API_URL}/partner`;

// Device id obtained from localStorage for backend logging purposes
export const AVAIL_DEVICE_INSTANCE_ID_KEY = "avail-device-instance-id";
